export default "__VITE_ASSET__36JI3V6p__"